import { trackChangeBillDateInitiatePurchase } from '../../../helpers/changeBillingDate/analytics';
import { PAYMENT_ERROR_GROUPS, PAYMENT_ERROR_TYPES } from '../constants/paymentErrors';
import { PAYMENT_STAGES } from '../PaymentContextProvider';
import changeBillDateMethod from '../helpers/changeBillingDate';
import { BILLING_DATE_CHANGED } from '../../../actions/billing/changeBillingDate';

/*
  Starts the change-billing-date flow by submitting the payment method token.
  Routes to:
  - Success (billing date changed)
  - 3DS authorization (if required)
  - Failure (show error and restart)
*/
const changeBillingPaymentMethodTransition =
  (paymentContext, { newMethodToken, paymentType, selectedBillDate }, runBeforeTransition) =>
  async dispatch => {
    const { addPaymentToken, goToPaymentStage, raisePaymentError } = paymentContext;

    // Store payment token in context for later use
    addPaymentToken({ paymentMethodToken: newMethodToken, paymentType });
    const purchasePayload = {
      selectedBillDate,
      paymentMethodToken: newMethodToken,
    };

    try {
      if (paymentType === 'existing_card') {
        goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_LOADING);
      } else {
        goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_PROCESSING);
      }

      const changeResult = await dispatch(changeBillDateMethod(purchasePayload));
      const { complete, threeDSecureActionTokenId, data } = changeResult;

      await runBeforeTransition?.();

      if (complete) {
        trackChangeBillDateInitiatePurchase(true);
        if (data) {
          dispatch({ type: BILLING_DATE_CHANGED, payload: data });
        }
        goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_SUCCESS);
        return;
      }

      if (threeDSecureActionTokenId) {
        trackChangeBillDateInitiatePurchase(true);
        // Payment method requires authorization as we have received a 3DS identifier in the response
        addPaymentToken({ authorizationInput: threeDSecureActionTokenId });
        goToPaymentStage(PAYMENT_STAGES.REQUIRES_AUTHORIZATION);
        return;
      }

      trackChangeBillDateInitiatePurchase(false);

      // Failure, prompt a user to try a different card
      raisePaymentError({
        message: 'Failed to process payment method',
        group: PAYMENT_ERROR_GROUPS.TOKENIZATION,
        type: PAYMENT_ERROR_TYPES.TOKENIZATION.INITIATING_PURCHASE,
      });
      goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_FAILURE);
    } catch (error) {
      await runBeforeTransition?.();
      raisePaymentError({
        message: error.message || 'Failed to process payment method',
        group: PAYMENT_ERROR_GROUPS.TOKENIZATION,
        type: PAYMENT_ERROR_TYPES.TOKENIZATION.INITIATING_PURCHASE,
      });
      goToPaymentStage(PAYMENT_STAGES.CHANGE_BILLING_DATE_FAILURE);
    }
  };

export default changeBillingPaymentMethodTransition;
